import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

const Divider = ({ classOverride }: { classOverride?: string }) => {
  return (
    <div
      className={twMerge(
        classNames('h-[1px] bg-stroke-divider my-[3px]', classOverride),
      )}
    />
  );
};

export default Divider;
